import { Component, Input, OnInit } from '@angular/core';

/**
 * Service Import.
 */
import { GetService } from '../../dataservices/get.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';

/**
 * Constants import.
 */
import { NUMBERS, STATUS_CODE } from './../../constants/app.constants';

@Component({
  selector: 'app-leaderboard',
  templateUrl: './leaderboard.component.html',
  styleUrls: ['./leaderboard.component.scss']
})
export class LeaderboardComponent implements OnInit {

  @Input() gameId: number;

  public topScores = true;
  public topScoresArray = [];

  public listData; any;
  public offset = 1;
  public busyLoadingData = false;
  public numbers = NUMBERS;
  public status_code = STATUS_CODE;
  public isFinished = true;

  /**
   * Input used to get and set players count.
   */
  @Input() playersCount: number;
  constructor(
    private getSer: GetService,
    public fcs: FunCollectionService,
    public mls: NewLanguageService) { }

  ngOnInit(): void {
    this.getLeaderBoardList();
  }


  getLeaderBoardList(): void {
    this.isFinished = false;
    this.getSer.getLeaderBoard(this.offset, this.gameId).subscribe(data => {
      if (data.status === this.numbers.ONE && data.code === this.status_code.TWO_THOUSAND) {
        this.busyLoadingData = false;
        this.isFinished = true;
        if (this.offset === NUMBERS.ONE) {
          this.listData = data.data;
          this.topScoresArray = this.listData?.leaderboard.slice(0, 3);
        } else {
          this.listData.leaderboard = this.listData.leaderboard.concat(data.data.leaderboard);
        }
        this.offset = data.data.offset;
      } else {
        this.isFinished = true;
        this.fcs.errorHandeler(data);
      }
    });
  }

  /**
   * navigate to profile.
   */
  navigateToProfile(customId: string): void {
    this.fcs.navigateToUserProfie(customId);
  }

  /**
   * infinite scroll
   */
  onScroll(): void {
    if (this.offset !== 0) {
      this.busyLoadingData = true;
      this.getLeaderBoardList();
    }
  }
}
